export default __webpack_public_path__ + "static/florian-valeye-28b638d1cbb5e0d254216ed64feee018.jpeg";